import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { apiUrl } from "../commons/inFormTypes";
import { IPUrl } from "../commons/IPAddress";
import SmoothList from "react-smooth-list";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Ssn_505343020 from '../../src/assets/img/Ssn_505343020.jpg'
import Transportation from '../../src/assets/img/Transportation.gif'
import Ssn_774994776 from '../../src/assets/img/Ssn_774994776.jpg'


function DashboardInternal() {
  const [seenFile, setSeenFile] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate();
  let { internalId } = useParams();

  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {
      var data = new FormData();
      data.append("id", internalId);
      const axios = require("axios");
      axios({
        method: "post",
        url: apiUrl + "items",
        headers: {
          'Access-Control-Allow-Origin': "*",
          Accept: "application/json",
          Authorization: "Bearer " + userToken,
        },
        data: data,
      }).then((res) => {
        if (res.data.success) {
          setSeenFile(res.data.result);
        } else {
        }
      });
    }
  }, []);

  return (
    <div>
      <main>
        <div className="pt-3 pt-lg-5">
          <Container className="m-auto">
            <Row className="justify-content-center mb-3 no-gutters">
              <Col xs={12} md={11} lg={9} className="mt-3">
                <Row className="justify-content-start g-2 g-sm-4">
                  <Col xs={12} style={{ direction: "ltr" }} className="d-block d-lg-none my-3">
                    <Carousel
                      autoPlay={true}
                      showThumbs={false}
                      infiniteLoop={true}
                      interval={3000}
                    >
                      <div>
                        <img className="rgc-carousel" src={Ssn_505343020} alt="Chrysanthemum" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={Transportation} alt="Hydrangeas" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={Ssn_774994776} alt="Jellyfish" />
                      </div>
                    </Carousel>
                  </Col>
                  {seenFile.map((data, index) => {
                    return (
                      <Col key={index} xs={4} md={4} lg={3} className="sub-side">
                        <SmoothList
                          delay={200}
                          animated={true}
                          visible={true}
                          transitionDuration={400}
                        >
                          <NavLink to={`/admin/service/${data.url}`}>
                            <div className="card rgc-card">
                              <div className="card-body my-1">
                                <img src={IPUrl + data.image}
                                  alt=""
                                  className="rgc-img-dash img-fluid mt-sm-3" />
                                <h6 className="card-title mt-2 mt-sm-3">{data.title}</h6>
                              </div>
                            </div>
                          </NavLink>
                        </SmoothList>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </main>
    </div>
  );
}

export default DashboardInternal;
